module.exports = __webpack_public_path__ + "img/1_222@2x.1f51bc20.png";